<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      providerData: 'providerData',
      user: 'user'
    })
  }
}
</script>

<template>
  <div class="has-text-centered create-page">
    <p
      class="is-cs-5 is-c-text"
      v-if="!user.uid || providerData.isAnonymous"
    >
      <router-link
        class="is-c-text"
        :to="{name: 'sign-in'}"
      >
        アカウントを開設して5分で作れる
      </router-link>
    </p>
    <router-link
      class="button is-large is-c-primary is-rounded has-text-white"
      :to="{name: 'page-creator'}"
    >
      ショップを作成
    </router-link>
  </div>
</template>

<style scoped>
p {
  margin-bottom: .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/lp/create-page-button.vue